import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_ds_get_order_classes_by_orderClassIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderClassIds: number[] }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderClassIds)) {
      missingRequiredInParams.push('\'orderClassIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_order_classes_by_orderClassIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderClassIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderClassIds)) {
      missingRequiredInParams.push('\'orderClassIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_order_classes_by_orderClassIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderClassIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, AllowInactiveInventory?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderClassIds)) {
      missingRequiredInParams.push('\'orderClassIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_order_classes_by_orderClassIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderClassIds: number[]    }) {
        if(isNil(inParams.orderClassIds)) {
          return true; 
        }
      return false;
    }
}
